export { wrapRootElement } from './src/util/wrap-root-element';

// eslint-disable-next-line no-unused-vars
const onRouteUpdate = ({ location }) => {
  if (window.fbq) {
    window.fbq(`track`, `ViewContent`);
  }
};

export { onRouteUpdate };
